module.exports = __webpack_public_path__ + "static/media/plumbing-equipment.c2beea87.jpg";